import { render, staticRenderFns } from "./OcrResultsOverlay.vue?vue&type=template&id=5ae2c525&"
import script from "./OcrResultsOverlay.vue?vue&type=script&lang=ts&"
export * from "./OcrResultsOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./OcrResultsOverlay.vue?vue&type=style&index=0&id=5ae2c525&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports